<template lang="pug">
.prices
    .row
        .flex.md12.list
            .item.row(v-for="(item, index) in prices" :key="'price_'+index")
                .flex.md11
                    .row
                        .flex.md3.sm12
                            va-input(v-model="item.fields.from_quantity.value" :error="item.fields.from_quantity.error" type="number" :label="$t('catalog.product.from_quantity')")
                        .flex.md3.sm12
                            va-input(v-model="item.fields.to_quantity.value" :error="item.fields.to_quantity.error" type="number" :label="$t('catalog.product.to_quantity')")
                        .flex.md3.sm12
                            va-input(v-model="item.fields.net_value.value" :error="item.fields.net_value.error" disabled type="number" :label="$t('catalog.product.net_value')")
                        .flex.md3.sm12
                            va-input(v-model="item.fields.gross_value.value" :error="item.fields.gross_value.error" @input="updateNetValue(index)" type="number" :label="$t('catalog.product.gross_value')")                                
                .flex.md1
                    va-button(color="danger" @click.prevent="removePrice(index)" icon="fa fa-trash")


    .row.actions
        .flex.md12
            va-button(color="success" @click.prevent="addPrice")
                | {{$t('catalog.product.addPrice')}}
</va-button>


</template>

<script>
export default {
    props : ['prices','vat'],
    data(){
        return {
            price : {
                fields : {
                    from_quantity : {value: null, required: true, error: false},
                    to_quantity : {value: null, required: false, error: false},
                    net_value : {value: null, required: true, error: false},
                    gross_value : {value: null, required: false, error: false}
                }
            }

        }
    },
    watch: {
        vat(t,f){
            for(var i in this.prices){
                this.updateNetValue(i);
            }
        }
    },
    methods : {
        addPrice(){
            this.prices.push(JSON.parse(JSON.stringify(this.price)));
        },
        removePrice(i){
            this.$emit('removePrice',i)
            this.prices.splice(i,1);
        },
        updateNetValue(index){
            var netValue = 0;
            netValue = parseFloat((this.prices[index].fields.gross_value.value * 100) / (100 + this.vat));
            this.prices[index].fields.net_value.value = parseFloat(netValue.toFixed(2))
        }
    }

}
</script>